import React from 'react'
import { Col, Form, FormControlProps, Row } from 'react-bootstrap'

interface FormDatePickerProps extends Omit<FormControlProps, 'value'> {
	name: string
	value: string | null | undefined // yyyy-MM-dd
	label?: string
	required?: boolean
	feedback?: string
	min?: string
	labelCol?: number
	labelJustify?: 'start' | 'end' | 'center' | 'between' | 'around'
}

const FormDate = (props: FormDatePickerProps) => {
	const control = (
		<>
			<Form.Control type={'date'} {...props} min={props.min} value={props.value || ''} />
			{props.feedback ? <Form.Control.Feedback type="invalid">{props.feedback}</Form.Control.Feedback> : null}
		</>
	)

	return (
		<Form.Group
			controlId={props.name}
			as={props.labelCol !== undefined ? Row : undefined}
			className={props.labelCol !== undefined ? 'align-items-center' : undefined}
		>
			{props.label ? (
				<Form.Label
					column={props.labelCol !== undefined ? true : undefined}
					sm={props.labelCol || undefined}
					className={props.labelJustify ? `d-flex justify-content-${props.labelJustify}` : undefined}
				>
					{props.label}
					{props.required ? ' *' : ''}
				</Form.Label>
			) : null}
			{props.labelCol !== undefined ? <Col sm={12 - props.labelCol}>{control}</Col> : control}
		</Form.Group>
	)
}

export { FormDate }
